import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { LayoutService, NavbarBtn, ToolbarDetails } from 'src/app/layout/layout.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-tobeonline-navbar',
  templateUrl: './tobeonline-navbar.component.html',
  styleUrls: ['./tobeonline-navbar.component.scss']
})
export class TobeonlineNavbarComponent implements OnInit {

  toolbarDetails: ToolbarDetails = {
    title: "Dashboard",
  };
  toolbarState: { [key: string]: boolean } = {};

  isRouteUser: boolean;
  isSuperAdmin!: boolean;

  // this.isSuperAdmin = this.originalUser.UserType == 'superadmin' ? true : false;

  constructor(
    public layoutService: LayoutService,
    private location: Location,
    public configService: ConfigService,
  ) { }

  ngOnInit(): void {
  }

  public onButtonClick(btn: NavbarBtn){
    this.layoutService.emitButtonClick(btn);
  }

  public openSideNav() {
    document.getElementById("mySidenav").style.width = "80%";
    document.getElementById("myCloseContainer").style.width = "20%";
  }

  public goBack() {
    this.location.back();
  }
}
